import { createFileRoute } from "@tanstack/react-router";
import { parseAlbumSearch } from "@/features/album-manager/search";

/**
 * Trang Quản lý album. Trang, ô tìm và bộ lọc nằm trên đường dẫn
 * (`?page=3&q=thu&mine=true`) — mở album rồi bấm Quay lại là về đúng chỗ.
 */
export const Route = createFileRoute("/_app/albums/")({
  validateSearch: parseAlbumSearch,
});
